import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

export const useAuthStore = defineStore('auth', () => {
    // Use useLocalStorage from @vueuse/core for persistent state
    const cookieToken = useCookie<string | null>('auth-token', {
        path: '/',      // Cookie available for all routes
        secure: process.env.NODE_ENV === 'production',   // Use secure cookies if you are in production (HTTPS)
        sameSite: 'strict',  // Prevent CSRF attacks
        httpOnly: false, // You can set this to true if cookies are only needed server-side
        maxAge: 60 * 60 * 24 * 7,
        expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
    });

    const token = ref<string | null>(cookieToken.value);

    const initializeToken = async () => {
        token.value = cookieToken.value;
    };

    // Actions
    const setToken = (newToken: string | undefined) => {
        if (newToken !== undefined) {
            token.value = newToken;
            cookieToken.value = newToken;
        }
    };

    const clearToken = () => {
        token.value = null;
        cookieToken.value = null;
    };

    function reset() {
        clearToken();
    }

    return {
        token: computed(() => token.value),
        initializeToken,
        setToken,
        clearToken,
        reset
    };
});
